export const jsonHeaders = () => ({
    "Content-Type": "application/json",
    "Accept": "application/json"
});

export const authHeaders = (json = true) => {

    const headers = {
        "Accept": "application/json",
        "Authorization": "Bearer " + localStorage.getItem("token")
    };

    if (json) {
        headers["Content-Type"] = "application/json";
    }

    return headers;
};